<div class="footer-container"
  *ngIf="!isAdminPage"
  [class.is-inverted]="isInverted">

  <div class="footer-content">
    <div class="footer-top">
      <div>
        <a class="footer-name" routerLink="/">
          lowercaseproductions
        </a>
      </div>

      <div>
        <a class="footer-contact" routerLink="/contact"
          (click)="handleSelectContact($event)">
          connect with us
        </a>
      </div>
    </div>

    <div class="footer-bottom">
      lcp San Francisco | 415 994 6653 | <a href="mailto:info@lowercaseproductions.com" target="_blank" title="email us">info&#64;lowercaseproductions.com</a>
    </div>
  </div>
</div>

<!-- <div class="footer-container"
  *ngIf="!isAdminPage"
  [class.is-inverted]="isInverted">

  <div class="footer-content">
    <div class="footer-left">
      <a class="footer-logo-link" routerLink="/contact">
        <span class="year">©{{ year }}</span>
        l<span>ower</span>c<span>ase </span>p<span>roductions</span>
      </a>
    </div>

    <div class="footer-right">
      <a class="footer-contact-link"
        routerLink="/contact">
        contact us
      </a>
    </div>
  </div>
</div> -->

<!-- <div class="footer-bottom">
  <div class="footer-right">
    <div class="flex-10a"></div>

    <ng-container *ngIf="!isLoggedIn">
      <a mat-button
        class="footer-bottom-link"
        (click)="apiService.navigateToLoginPage()"
        routerLinkActive="is-active">
        log in
      </a>
    </ng-container>

    <ng-container *ngIf="isLoggedIn">
      <a mat-button
        class="footer-bottom-link"
        routerLink="/admin"
        routerLinkActive="is-active"
        [routerLinkActiveOptions]="{ exact: true }">
        admin
      </a>

      <span class="footer-divider">|</span>

      <a mat-button
        class="footer-bottom-link"
        (click)="authService.logout()"
        routerLink="/">
        log out
      </a>
    </ng-container>
  </div>
</div> -->